import type { EventTypeCode } from "../types/events";
import type { EventFieldFormat } from "./events.config";

function formatNumber(value: number | string): string {
	const numberValue = typeof value === "number" ? value : Number(value);
	if (Number.isNaN(numberValue)) {
		return String(value);
	}
	return numberValue.toLocaleString("pt-BR", {
		maximumFractionDigits: Number.isInteger(numberValue) ? 0 : 2,
	});
}

function formatTimeValue(totalSeconds: number | string): string {
	const seconds = Number(totalSeconds);
	if (Number.isNaN(seconds) || seconds < 0) {
		return String(totalSeconds);
	}

	const mins = Math.floor(seconds / 60);
	const secs = seconds % 60;

	if (mins === 0) {
		return `${secs}s`;
	}
	if (secs === 0) {
		return `${mins}min`;
	}
	return `${mins}min ${secs}s`;
}

function formatBooleanPt(raw: boolean): string {
	return raw ? "Sim" : "Não";
}

function formatNumericField(
	format: EventFieldFormat,
	numValue: number,
	raw: number | string
): string | null {
	if (Number.isNaN(numValue)) {
		return null;
	}

	if (format === "seconds") {
		return formatTimeValue(numValue);
	}
	if (format === "kmh") {
		return `${formatNumber(numValue)} Km/h`;
	}
	if (format === "km") {
		return `${formatNumber(numValue)} km`;
	}
	if (format === "limit_kmh") {
		return `${formatNumber(numValue)} Km/h`;
	}
	if (format === "limit_g") {
		return `${formatNumber(numValue)} G`;
	}
	if (format === "number") {
		return formatNumber(numValue);
	}

	if (format === "boolean_pt") {
		return null;
	}

	if (format === "text") {
		return null;
	}

	return String(raw);
}

export function formatEventFieldValue(
	format: EventFieldFormat,
	raw: number | string | boolean,
	_eventType: EventTypeCode
): string {
	if (typeof raw === "boolean") {
		return formatBooleanPt(raw);
	}

	const numValue = Number(raw);
	const formatted = formatNumericField(format, numValue, raw);
	if (formatted !== null) {
		return formatted;
	}

	return String(raw);
}
